import cn from "classnames";
import { NavLink, useSearchParams } from "react-router-dom";
import Icon from "@components/new/Icon";
import { Title2, SubTitle3 } from '@components/new/Typo';
import { TMenuSubItem } from "../../types";
import Dropdown, { DropdownOptionProps } from "@components/Dropdown";
import styles from "./MenuItem.module.scss";

export const MenuItem = ({ icon, title, counter, disabled, path, subpages, collapsed }: {
  icon?: string | React.FunctionComponent<React.SVGAttributes<SVGElement>>;
  title: string;
  path: string;
  counter?: number | string;
  disabled?: boolean;
  subpages?: TMenuSubItem[];
  collapsed?: boolean;
}) => {
  const OptionComponent = ({ value }: DropdownOptionProps<string, TMenuSubItem>) => {
    return (
      <MenuItem
        key={value?.id}
        icon={value?.icon}
        title={value?.title ?? ""}
        path={value?.path ?? ""}
        counter={value?.count}
        disabled={value?.disabled}
      />
    );
  }

  const ValueComponent = () => {
    return (
      <div
        className={cn(
          styles.menuItem,
          disabled && styles.disabled,
          styles.collapsed,
        )}
      >
        {icon ? (
          <Icon icon={icon} className={styles.icon} />
        ) : null}
        {counter ? (
          <SubTitle3 className={styles.count}>
            {counter}
          </SubTitle3>
        ) : null}
      </div>
    )
  }

  if (collapsed && subpages?.length) {
    return (
      <Dropdown<string, TMenuSubItem>
        onChange={() => {}}
        OptionComponent={OptionComponent}
        ValueComponent={ValueComponent}
        options={subpages.map(v => ({ id: v.id, value: v }))}
        defaultOption={{ id: subpages[0]?.id, value: subpages[0] }}
        menuPosition="right"
        menuWidth="240px"
        fixed
      />
    );
  }

  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab')
  const itemTab = new URLSearchParams(path).get('tab');

  const isLinkActive = (isActive: boolean) => (
    isActive && !subpages?.length && (!itemTab || (itemTab === activeTab))
  )

  if (collapsed) {
    return (
      <NavLink
        className={({ isActive }) => cn(
          styles.menuItem,
          isLinkActive(isActive) && styles.active,
          disabled && styles.disabled,
          styles.collapsed,
        )}
        to={path}
      >
        {icon ? (
          <Icon icon={icon} className={styles.icon} />
        ) : null}
        {counter ? (
          <SubTitle3 className={styles.count}>
            {counter}
          </SubTitle3>
        ) : null}
      </NavLink>
    );
  }

  return (
    <>
      <NavLink
        className={({ isActive }) => cn(
          styles.menuItem,
          isLinkActive(isActive) && styles.active,
          disabled && styles.disabled,
        )}
        to={path}
      >
        {icon ? (
          <Icon icon={icon} className={styles.icon} />
        ) : null}
        <Title2>{title}</Title2>
        {counter ? (
          <SubTitle3 className={styles.count}>
            {counter}
          </SubTitle3>
        ) : null}
      </NavLink>
      {(subpages?.length) ? (
        <div className={styles.subpages}>
          {(subpages || []).map(v => (
            <MenuItem
              key={v.id}
              icon={v.icon}
              title={v.title}
              path={v.path ?? `${path}?tab=${v.id}`}
              counter={v.count}
              disabled={v.disabled}
            />
          ))}
        </div>
      ) : null}
    </>
  );
};
